module.exports = __webpack_public_path__ + "img/cowork-white.6e4680aa.svg";